// Bootstrap loader oficial de Google Maps (soporta importLibrary).
// Necesario para usar Places API (New): AutocompleteSuggestion, etc.

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    google?: any;
    __gmapsBootstrapped?: boolean;
  }
}

const BROWSER_KEY = import.meta.env.VITE_LOVABLE_CONNECTOR_GOOGLE_MAPS_BROWSER_KEY as
  | string
  | undefined;
const CHANNEL = import.meta.env.VITE_LOVABLE_CONNECTOR_GOOGLE_MAPS_TRACKING_ID as
  | string
  | undefined;

export function hasGoogleMapsKey() {
  return !!BROWSER_KEY;
}

function bootstrap(apiKey: string, channel?: string) {
  if (typeof window === "undefined") return;
  if (window.__gmapsBootstrapped) return;
  window.__gmapsBootstrapped = true;
  // Snippet oficial "Dynamic Library Import":
  // https://developers.google.com/maps/documentation/javascript/load-maps-js-api
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ((g: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let h: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let a: any;
    let k: string;
    const p = "The Google Maps JavaScript API";
    const c = "google";
    const l = "importLibrary";
    const q = "__ib__";
    const m = document;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w: any = window;
    const b = (w[c] = w[c] || {});
    const d = (b.maps = b.maps || {});
    const r = new Set<string>();
    const e = new URLSearchParams();
    const u = () =>
      h ||
      (h = new Promise<void>((f, n) => {
        a = m.createElement("script");
        e.set("libraries", [...r].join(","));
        for (k in g)
          e.set(
            k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
            g[k],
          );
        e.set("callback", c + ".maps." + q);
        a.src = `https://maps.googleapis.com/maps/api/js?` + e.toString();
        d[q] = f;
        a.onerror = () => {
          h = null;
          n(new Error(p + " could not load."));
        };
        a.nonce = (m.querySelector("script[nonce]") as HTMLScriptElement)?.nonce || "";
        m.head.append(a);
      }));
    if (d[l])
      console.warn(p + " only loads once. Ignoring:", g);
    else
      d[l] = (f: string, ...n: unknown[]) =>
        r.add(f) && u().then(() => d[l](f, ...n));
  })({
    key: apiKey,
    v: "weekly",
    language: "es",
    region: "ES",
    ...(channel ? { channel } : {}),
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function importPlaces(): Promise<any> {
  if (typeof window === "undefined") throw new Error("SSR");
  if (!BROWSER_KEY)
    throw new Error("Falta VITE_LOVABLE_CONNECTOR_GOOGLE_MAPS_BROWSER_KEY");
  bootstrap(BROWSER_KEY, CHANNEL);
  return window.google.maps.importLibrary("places");
}
